<template>
<v-app>

  <v-container>
  <v-row class="mt-5 pt-5 mb-5">
  <v-col md3="md3"></v-col>
  <v-col md6="md6" xs12="xs12" class="mt-2">

  <!-- <div class="display-3">&nbsp;</div> -->
  <div class="display-2">{{title}}</div>
    <blockquote style="border-left: 0px; padding-left: 0rem;">
      <v-icon class="display-1 primary--text pr-2" style="vertical-align: bottom">people</v-icon>
      {{subtitle}}
    </blockquote>
    <p>{{text}}</p>

</v-col>
</v-row>
</v-container>

<!-- <v-card class="primary mt-0" height="200px" /> -->

</v-app>
</template>

<script>
// Firebase
// import firebase from '../modules/firebase'
// Locale
// import locale from '../modules/locale'

export default {
  data () {
    return {
      title: 'Grazie!',
      subtitle: 'La tua richiesta è stata accolta',
      text: 'Al prossimo incontro del Consiglio Direttivo, ' +
      'riceverai conferma del buon esito della tua iscrizione a 5pani2pesci, ' +
      'insieme agli estremi bancari per poter versare la quota associativa.'
    }
  },
  methods: {
  }
}
</script>

<style scoped>
blockquote{
  border-left: 0px;
  padding-left: 0rem;
}
</style>



// WEBPACK FOOTER //
// Submitted.vue?9f7c041e